const rmsReducers = {};

export default rmsReducers;
